<template>
  <div id="home">
    <router-link :to="{ name: 'clusters' }">
      <img :src="require('../assets/section1.png')" />
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'home',
  methods: {

  },
  created (){

  },
  mounted (){

  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style lang="scss">
@import '../scss/global';

#home {
  text-align: center;

  img {
    margin: 0;
    width: 100%;

    &:nth-of-type(2) {
      margin-top: 6em;
      width: 80%;
    }
  }
}

.big-button {
  background: $primary-color;
  border-radius: 30px;
  font-size: 22px;
  padding: 10px 80px;
  display: inline-block;
  color: $white;
  text-decoration: none;
  box-shadow: 5px 5px 15px transparentize(#000, 0.4);
  transition: all $animation-speed;
  &:hover {
    color: $white;
    background: lighten($primary-color, 5%);
  }
}
</style>



// WEBPACK FOOTER //
// Home.vue?a3dafffc